export enum EmployerModuleType {
    ALLOWANCES = "ALLOWANCES",
    GIFTING = "GIFTING",
    PUBLIC_TRANSPORT = "PUBLIC_TRANSPORT",
    REWARDS_RECOGNITION = "REWARDS_RECOGNITION"
}
  
  